import { useNavigate } from 'react-router-dom';
import Typography from '../../sharedComponents/Typography/Typography';
import DashboardIcon from './DashboardIcon';
import { quickLinks } from './homeAuthed.constants';
import styles from './home-authed.module.scss';

const QuickLinks: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.dashboardSection} aria-labelledby="shortcuts">
      <div className={styles.sectionHeadingCompact} id="shortcuts">
        <Typography variant="h5">Quick shortcuts</Typography>
      </div>
      <div className={styles.quickLinks}>
        {quickLinks.map((quickLink) => (
          <button
            type="button"
            key={quickLink.href}
            className={styles.quickLink}
            onClick={() => navigate(quickLink.href)}
            aria-label={`${quickLink.label}: ${quickLink.description}`}
          >
            <span className={styles.quickLinkIcon}>
              <DashboardIcon name={quickLink.icon} />
            </span>
            <Typography variant="label-3">{quickLink.label}</Typography>
            <span className={styles.quickLinkArrow}>
              <DashboardIcon name="arrow" />
            </span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default QuickLinks;
